import _ from 'lodash'
import Mousetrap from 'mousetrap'

let keys = {}

function unbindForKey (key) {
  Mousetrap.unbind(key)
}
function bindToLastForKey (key) {
  if (keys[key]) {
    Mousetrap.bind(key, _.last(keys[key]).fn)
  }
}
function cleanAndBind (key) {
  if (keys[key].length === 0) {
    delete keys[key]
    unbindForKey(key)
  } else {
    bindToLastForKey(key)
  }
}

function unbindLabelAt (label, key) {
  _.remove(keys[key], (e) => e.label === label)
}

function bind (key, fn, label = 'default') {
  if (!keys[key]) {
    keys[key] = []
  } else {
    unbindForKey(key)
  }
  let binding = _.find(keys[key], (e) => e.label === label)
  if (binding) {
    binding.fn = fn
  } else {
    keys[key].push({
      label: label,
      fn: fn
    })
  }
  bindToLastForKey(key)
}
function bindAll (bindings, label = 'default') {
  _.forOwn(bindings, (fn, key) => {
    bind(key, fn, label)
  })
}
function unbind (key, label = 'default') {
  if (!keys[key]) {
    return
  }
  unbindForKey(key)
  unbindLabelAt(label, key)
  cleanAndBind(key)
}
function unbindLabel (label = 'default') {
  _.forOwn(keys, (binding, key) => {
    unbindLabelAt(label, key)
    cleanAndBind(key)
  })
}

function getKeys () { // for debug
  return keys
}

function currentKeys () {
  let currentKeys = {}
  _.forOwn(keys, (binding, key) => {
    currentKeys[key] = _.last(binding).label
  })
  return currentKeys
}
window.keys = keys

export default {
  bind,
  bindAll,
  unbind,
  unbindLabel,
  getKeys,
  currentKeys
}



// WEBPACK FOOTER //
// ./src/components/shared/mousetrapManager.js